import { useState } from "react";
import { Card } from "./Layout";
import { Button } from "./ui/button";
import { Label } from "./ui/label";
import { PasswordInput } from "./PasswordInput";
import { apiError, http } from "../lib/api";

/** Cambio de contraseña permanente, válido en todos los dispositivos. */
export const ChangePassword = ({ testid = "change-password" }) => {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [repeat, setRepeat] = useState("");
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setMsg(""); setError("");
    if (next.length < 8) return setError("La contraseña nueva debe tener al menos 8 caracteres.");
    if (next !== repeat) return setError("Las dos contraseñas nuevas no coinciden.");
    setBusy(true);
    try {
      const { data } = await http.post("/auth/change-password",
        { current_password: current, new_password: next });
      if (data.token) localStorage.setItem("sisu_token", data.token);
      setMsg(data.message);
      setCurrent(""); setNext(""); setRepeat("");
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Card data-testid={`${testid}-card`}>
      <h2 className="font-head text-2xl font-medium">Cambiar mi contraseña</h2>
      <p className="mt-2 text-base text-ink-700">
        El cambio es inmediato y permanente: la contraseña nueva sirve en el móvil, en la tableta y
        en el ordenador. Puede pulsar el ojo para ver lo que escribe.
      </p>
      <form onSubmit={submit} className="mt-5 max-w-md space-y-5">
        <div>
          <Label htmlFor={`${testid}-current`} className="text-base">Contraseña actual</Label>
          <PasswordInput id={`${testid}-current`} testid={`${testid}-current-input`} required
            autoComplete="current-password" value={current}
            onChange={(e) => setCurrent(e.target.value)} className="mt-2 h-14 text-lg" />
        </div>
        <div>
          <Label htmlFor={`${testid}-new`} className="text-base">Contraseña nueva (mínimo 8 caracteres)</Label>
          <PasswordInput id={`${testid}-new`} testid={`${testid}-new-input`} required
            autoComplete="new-password" value={next}
            onChange={(e) => setNext(e.target.value)} className="mt-2 h-14 text-lg" />
        </div>
        <div>
          <Label htmlFor={`${testid}-repeat`} className="text-base">Repetir la contraseña nueva</Label>
          <PasswordInput id={`${testid}-repeat`} testid={`${testid}-repeat-input`} required
            autoComplete="new-password" value={repeat}
            onChange={(e) => setRepeat(e.target.value)} className="mt-2 h-14 text-lg" />
        </div>
        {msg && <p data-testid={`${testid}-success`} className="rounded-lg bg-logo-light p-4 text-base text-logo-text">{msg}</p>}
        {error && <p data-testid={`${testid}-error`} className="rounded-lg bg-red-50 p-4 text-base text-red-700">{error}</p>}
        <Button data-testid={`${testid}-submit`} disabled={busy} className="h-14 text-lg">
          {busy ? "Guardando..." : "Guardar la contraseña nueva"}
        </Button>
      </form>
    </Card>
  );
};
